import React from 'react'
import './Home.css';
import FAQs from '../FAQs/FAQs';
import Services from '../Services/Services';
import About from '../About/About';

const Home = () => {
  return (
    <div className='home-container'>
        <div className='logo-div'>
            <img className="company-logo" src={require("../../images/bobs-logo.jpg")} alt='Company Logo'/>
            <p>
                <br />
            Dent And Scratch Repair, At Your Doorstep!<br />
            </p>
            <div className="locations">Serving: Springfield, Mclean, Bethesda, Chevy Chase, Fairfax, Arlington, Burke and Rockville.</div>
        </div>
        {<About />}
        {<FAQs />}
        {<Services />}
    </div>
  )
}

export default Home